<div class="qms-paginator-outer-container" [class.size-small]='size == sizeSmall' [class.d-none]='numHidden > length'>
    <div class="mat-paginator-container" *ngIf='size != sizeMobile'>
        <div class="qms-total-result" [class.mr-b-size-small]='size == sizeSmall'>
            <span>{{'COMMON.RESULTS' | translate}}: {{length}}</span>
        </div>
        <div class="qms-paginator-page-size" *ngIf='size != sizeSmall'>
            <div class="qms-pagesize-label">{{'COMMON.ROW_PER_PAGE' | translate}}:</div>
            <mat-form-field class="qms-form-page-size w-20" appearance="fill">
                <mat-select [panelClass]="overlayClass" [value]="pageSize"
                    (selectionChange)="_changePageSize($event.value)">
                    <mat-option *ngFor="let item of pageSizeOptions" [value]="item">
                        {{ item }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="qms-paginator-page-size" *ngIf='size != sizeMedium && size != sizeSmall'>
            <div class="qms-pagesize-label ">{{'COMMON.JUM_TO_PAGE' | translate}}:</div>

            <mat-form-field class="qms-form-page-size w-20" appearance="fill">
                <mat-select [panelClass]="overlayClass" [value]="pageIndex"
                    (selectionChange)="_changePageNumber($event.value)">
                    <mat-option *ngFor="let item of numberOfPages" [value]="item">
                        {{ item }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="qms-paginator-range-actions">
            <ul class="nav-list-pagination">
                <li class="nav-item">
                    <button mat-button class="!min-w-10" (click)='previousPage()' [disabled]='minPage == pageIndex'>
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                </li>
                <ng-container *ngFor='let item of displayNumberOfPages'>
                    <li class="nav-item"> <span *ngIf='item == "..."' class="qms-3d">{{item}}</span></li>
                    <li class="nav-item">
                        <button *ngIf='item != "..."' mat-button class="!min-w-10" [class.selected]='pageIndex == item'
                            [disabled]='pageIndex == item' (click)='changePage(+item)'>
                            {{item}}
                        </button>
                    </li>
                </ng-container>
                <li class="nav-item">
                    <button mat-button class="!min-w-10" (click)='nextPage()' [disabled]='maxpage == pageIndex'>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <div class="mat-paginator-container-mobile" *ngIf='size == sizeMobile'>
        <div class="mat-paginator-container" *ngIf='size == sizeMobile'>
            <div class="qms-paginator-range-actions">
                <ul class="nav-list-pagination">
                    <li class="nav-item">
                        <button mat-button class="!min-w-10" (click)='previousPage()' [disabled]='minPage == pageIndex'>
                            <mat-icon>chevron_left</mat-icon>
                        </button>
                    </li>
                    <ng-container *ngFor='let item of displayNumberOfPages'>
                        <li class="nav-item"> <span *ngIf='item == "..."' class="qms-3d">{{item}}</span></li>
                        <li class="nav-item">
                            <button *ngIf='item != "..."' mat-button class="!min-w-10"
                                [class.selected]='pageIndex == item' [disabled]='pageIndex == item'
                                (click)='changePage(+item)'>
                                {{item}}
                            </button>
                        </li>
                    </ng-container>
                    <li class="nav-item">
                        <button mat-button class="!min-w-10" (click)='nextPage()' [disabled]='maxpage == pageIndex'>
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="qms-total-result">
            <span>{{'COMMON.RESULTS' | translate}}: {{length}}</span>
        </div>
        <div style="display: flex;">
            <div class="qms-paginator-page-size" *ngIf='size != sizeSmall'>
                <div class="qms-pagesize-label">{{'COMMON.JUM_TO_PAGE' | translate}}:</div>
                <mat-form-field class="qms-form-page-size w-20" appearance="fill">
                    <mat-select [panelClass]="overlayClass" [value]="pageSize"
                        (selectionChange)="_changePageSize($event.value)" qms-select>
                        <mat-option *ngFor="let item of pageSizeOptions" [value]="item">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="qms-paginator-page-size" *ngIf='size != sizeMedium && size != sizeSmall'>
                <div class="qms-pagesize-label ">{{'COMMON.JUM_TO_PAGE' | translate}}:</div>
                <mat-form-field class="qms-form-page-size w-20" appearance="fill">
                    <mat-select [panelClass]="overlayClass" [value]="pageIndex"
                        (selectionChange)="_changePageNumber($event.value)" qms-select>
                        <mat-option *ngFor="let item of numberOfPages" [value]="item">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

    </div>

</div>